/* Asset URLs for Mum's Shed branding */
export const MUM_HERO_LOGO = "/mums-shed/mums-hero.png";
export const MUM_BANNER = "/mums-shed/mums-banner.png";
export const MUM_BG = "/mums-shed/background.png";

export const MUM_TILES = {
  tubers:   { src: "/mums-shed/tile-tubers.png",   to: "/mums-shed/tubers",   label: "Mum's Dahlia Tubers" },
  blooms:   { src: "/mums-shed/tile-blooms.png",   to: "/mums-shed/blooms",   label: "Mum's Dahlia Blooms" },
  flowers:  { src: "/mums-shed/tile-flowers.png",  to: "/mums-shed/flowers",  label: "Mum's Flowers" },
  seeds:    { src: "/mums-shed/tile-seeds.png",    to: "/mums-shed/seeds",    label: "Mum's Seeds" },
  journal:  { src: "/mums-shed/tile-journal.png",  to: "/mums-shed/journal",  label: "Journal" },
  database: { src: "/mums-shed/tile-database.png", to: "/mums-shed/database", label: "Database" },
  gallery:  { src: "/mums-shed/tile-gallery.png",  to: "/mums-shed/gallery",  label: "Gallery" },
  summary:  { src: "/mums-shed/tile-summary.png",  to: "/mums-shed/summary",  label: "Garden Summary" },
  wishlist: { src: "/mums-shed/tile-wishlist.png", to: "/mums-shed/wishlist", label: "Wishlist" },
  tasks:    { src: "/mums-shed/tile-tasks.png",    to: "/mums-shed/tasks",    label: "Garden Tasks" },
  builder:  { src: "/mums-shed/tile-builder.png",  to: "/mums-shed/builder",  label: "Garden Builder" },
};
